import { PullBingPurchaseData } from './../utils/data.type';
import axios, { AxiosResponse } from "axios";
import { FindRoiParams, GetDataAllDayParams, PullFacebookPurchaseData, PullFacebookPurchaseDataFromSite, PullGooglePurchaseData, RoiData, SelectUserParams, WarningData, WarningDataParams, BudgetData, BudgetDataParams, AdManagerDeviceSiteMetric, AdManagerHourIncomeMetric, AdManagerHourIncomeSyncSummary, AdManagerMetricList, AdManagerMetricSyncResult, AdManagerReportDateParams, AdManagerSiteHourlyMetric, AdManagerSiteQueryParams } from "../utils/data.type";
import { _message } from "../../../components/message";
import { ROIAPI } from "../env";
import { BingPullDataApi } from "../env";
import { PageParams } from '@/utils/datatype';



const RoiAxios = axios.create({
    baseURL: ROIAPI,
    timeout: 1800000
});

const BingAxios = axios.create({
    baseURL: BingPullDataApi,
    timeout: 1800000
});

RoiAxios.interceptors.request.use(config => config, error => Promise.reject(error));

RoiAxios.interceptors.response.use(response => {
    const result = response.data;
    if(result.code && result.code === 201 || !result.code) {
        return result;
    } else if(result.code && result.code !== 200) {
        // * 请求成功,但是业务逻辑失败
        _message.error(result.msg || '请求失败')
        return Promise.reject(new Error(result.msg || '请求失败'));
    }
    return result.data ? result.data : result;
}, error => {
    return Promise.reject(new Error(error?.response?.data?.msg || error?.response?.data?.message || error?.message || '网络请求失败'));
});

// * 选择用户
export const selectUser = (params: SelectUserParams) => RoiAxios.post('/user/api/select/user', {}, {
    params
});

// * 查询ROI
export const findRoi = (params: FindRoiParams, platform: string) => {
    switch(platform) {
        case 'facebook':
            return RoiAxios.post<any, RoiData>('/googleroi/fb/find', {}, {
                params
            });
        case 'bing': 
            return RoiAxios.post<any, RoiData>('/googleroi/bing/find', {}, {
                params
            });
        default:
            return RoiAxios.post<any, RoiData>('/googleroi/find', {}, { 
                params
            });
    }
}

// * 查询SnapRoi
export const findSnapRoi = (params: FindRoiParams & PageParams) => {
    return RoiAxios.post<any, any>('/api/snap/performance/data/list', params);
}

// * 拉取google买量数据
export const pullGoogleData = (params: PullGooglePurchaseData) => {
    return RoiAxios.post<any, any>('/googleads/fetch/data', params);
}

// * 同步facebook买量数据
export const pullFacebookData = (params: PullFacebookPurchaseDataFromSite) => {
    return RoiAxios.post<any, { code: number, msg: string }>('/fb/fetch/data/day', params);
}

// * 获取bing买量数据
export const pullBingData = (params: PullBingPurchaseData) => {
    return BingAxios.get<any, {data: { code: number, msg: string, data: string } }>('/api/report/generateReportByInMemory', { params });
}

// * 查询facebook同步结果
export const queryFacebookPurchase = (params: PullFacebookPurchaseDataFromSite) => {
    return RoiAxios.post<any, { code: number, msg: string }>('/fb/fetch/result/data', params);
}

//  * 检测是否可以同步指定FB用户的买量数据
export const checkFacebookPurchase = (params: PullFacebookPurchaseData) => {
    return RoiAxios.post<any,{  failedAdAccounts: string[], thereFailed: boolean, thereOnGoing: boolean }>('/fb/fetch/data/day/usercheck', params);
}

// * 根据用户同步facebook买量数据
export const pullFacebookDataByUser = (params: PullFacebookPurchaseData) => {
    return RoiAxios.post<any, { code: number, msg: string }>('/fb/fetch/data/userday', params);
}

// * 查询facebook用户数据同步结果
export const queryFacebookPurchaseByUser = (params: PullFacebookPurchaseData) => {
    return RoiAxios.post<any, { code: number, msg: string }>('/fb/fetch/result/userdata', params);
}



// * 获取全天数据
export const getDataAllDay = (params: GetDataAllDayParams) => {
    return RoiAxios.post<string, { code: number, msg: string }>('/googleadsense/fetch/data', params);
}
// * 获取全天数据(通过域名)
export const getDataAllDayByDomain = (params: any) => {
    return RoiAxios.post<string, { code: number, msg: string }>('/googleadsense/fetch/data/domain', params);
}

// * -------------- 以下为渠道报警相关接口 --------------

// * 获取平台列表
export const getPlatformList = () => {
    return RoiAxios.post<string, string[]>('/adWarning/medias');
} 

// * 获取警告类型列表
export const getWarningTypeList = () => {
    return RoiAxios.post<string, string[]>('/adWarning/warningTypes');
}

// * 获取渠道报警数据
export const getWarningData = (params: WarningDataParams) => {
    return RoiAxios.post<string,  Array<WarningData>>('/adWarning/hoursData', params);
}

// * 获取 Ad Manager 小时收入数据
export const getAdManagerHourIncomeMetrics = (params: AdManagerReportDateParams) => {
    return RoiAxios.get<string, AdManagerMetricList<AdManagerHourIncomeMetric>>('/admanager/rest/hour-income/list', { params });
}

// * 手动同步 Ad Manager 小时收入数据
export const syncAdManagerHourIncomeMetrics = () => {
    return RoiAxios.post<string, AdManagerHourIncomeSyncSummary>('/admanager/rest/hour-income/sync');
}

// * 获取 Ad Manager 设备网站数据
export const getAdManagerDeviceSiteMetrics = (params: AdManagerSiteQueryParams) => {
    return RoiAxios.get<string, AdManagerMetricList<AdManagerDeviceSiteMetric>>('/admanager/rest/device-site/list', { params });
}

// * 获取 Ad Manager 设备网站名称列表
export const getAdManagerDeviceSiteNames = (params: AdManagerReportDateParams) => {
    return RoiAxios.get<string, string[]>('/admanager/rest/device-site/sites', { params });
}

// * 手动同步 Ad Manager 设备网站数据
export const syncAdManagerDeviceSiteMetrics = () => {
    return RoiAxios.post<string, AdManagerMetricSyncResult>('/admanager/rest/device-site/sync');
}

// * 获取 Ad Manager 网站小时数据
export const getAdManagerSiteHourlyMetrics = (params: AdManagerSiteQueryParams) => {
    return RoiAxios.get<string, AdManagerMetricList<AdManagerSiteHourlyMetric>>('/admanager/rest/site-hourly/list', { params });
}

// * 获取 Ad Manager 网站小时名称列表
export const getAdManagerSiteHourlySiteNames = (params: AdManagerReportDateParams) => {
    return RoiAxios.get<string, string[]>('/admanager/rest/site-hourly/sites', { params });
}

// * 手动同步 Ad Manager 网站小时数据
export const syncAdManagerSiteHourlyMetrics = () => {
    return RoiAxios.post<string, AdManagerMetricSyncResult>('/admanager/rest/site-hourly/sync');
}

/**
 * 获取预算调整数据(Facebook平台)
 * @returns 
 */
export const getBudgetDataFromFB = (params: BudgetDataParams) => {
    return RoiAxios.post<string,  Array<BudgetData>>('/fb/queryBudgetAdjustmentRecords', params);
}

/**
 * 获取预算调整数据(google平台)
 * @returns 
 */
export const getBudgetDataFromGoogle = (params: BudgetDataParams) => {
    return RoiAxios.post<string,  Array<BudgetData>>('/googleads/queryBudgetAdjustmentRecords', params);
}

/**
 * 更新价格
 * @param params
 * @returns
 */
export const updateBudgetForFacebook = (params: any) => {
    return RoiAxios.post<string,  any>('/api/fb/adSet/operation/batchUpdateBudget', params);
}
/**
 * 关闭广告(支持批量)
 * @param params
 * @returns
 */
export const closeAdsStatus = (params: any) => {
    return RoiAxios.post<string,  any>('/api/fb/adSet/operation/batchPaused', params);
}

/**
 * 查询落地页
 * @param params
 * @returns
 */
export const getLandingPageList = (params: any) => {
    return RoiAxios.post<string,  any>('/api/google/finalUrlCost/list', params); 
}

/**
 * 拉取指定时间的数据
 * @param params
 * @returns
 */
export const fetchDataList = (params: any) => {
    return RoiAxios.post<string,  any>('/api/google/finalUrlCost/fetchData', params);
}

export const exportFiles=(params: any) => {
    return RoiAxios.post<string,  any>('/api/google/finalUrlCost/csv/export', params);
};

/**
 * 周/月选项
 * @returns
 */
export const getPerioidcOptions = (type: string, platform: string) => {
    const UrlOptionMapping : {[key: string]: any} = {
        google: {
            week: '/api/weekMonth/google/week/list',
            month: '/api/weekMonth/google/month/list'
        },
        facebook: {
            week: '/api/weekMonth/facebook/week/list',
            month: '/api/weekMonth/facebook/month/list'
        },
        snap: {
            week: '/api/weekMonth/snap/week/list',
            month: '/api/weekMonth/snap/month/list'
        }
    };
    const currentUrl = UrlOptionMapping[platform][type];
    return RoiAxios.get<string, any>(currentUrl);
};

/**
 * 查询时间段数据
 * @param params
 * @param type
 * @param platform
 * @returns
 */
export const getPerioidcData = (params: any, type: string, platform: string) => {
    const UrlMapping : {[key: string]: any} = {
        google: {
            week: '/api/weekMonth/google/weekData/list',
            month: '/api/weekMonth/google/monthData/list'
        },
        facebook: {
            week: '/api/weekMonth/facebook/weekData/list',
            month: '/api/weekMonth/facebook/monthData/list'
        },
        snap: {
            week: '/api/weekMonth/snap/weekData/list',
            month: '/api/weekMonth/snap/monthData/list'
        }
    };
    const currentUrl = UrlMapping[platform][type];
    return RoiAxios.post<string,  any>(currentUrl, params);
}

export const exportCSVData = (params: any, type: string, platform: string) => {
    const UrlExportMapping : {[key: string]: any} = {
        google: {
            week: '/api/weekMonth/google/weekData/export',
            month: '/api/weekMonth/google/monthData/export'
        },
        facebook: {
            week: '/api/weekMonth/facebook/weekData/export',
            month: '/api/weekMonth/facebook/monthData/export'
        },
        snap: {
            week: '/api/weekMonth/snap/weekData/export',
            month: '/api/weekMonth/snap/monthData/export'
        }
    };
    const currentUrl = UrlExportMapping[platform][type];
    return RoiAxios.post<string,  any>(currentUrl, params);
}

/**
 * 导出Snap平台csv数据
 * @param params
 * @returns 
 */
export const exportSnapCsvData = (params: any) => {
    return RoiAxios.get<any, string>('/api/snap/ori/data/export', {params});
};

/**
 * snap平台调价
 * @param params
 * @returns
 */
export const updateDataForSnap = (params: any) => {
    return RoiAxios.post<string,  any>('/api/snap/adSquads/update-budget-bid', params);
}

/**
 * 关闭广告
 * @param params
 * @returns
 */
export const closeAdsForSnap = (params: any) => {
    return RoiAxios.post<string,  any>('/api/snap/campaigns/update-status', params);
}
